import {
  CellPosition,
  CellRange,
  ICellPosition,
  ICellRange,
} from "@/components/excel/schema/BaseSchema";
import "@/utils/extensions/libs/ArrayExtension";
export interface ISelectCellOption {
  cell: ICellPosition;
  isMulti: boolean;
  isRange: boolean;
}
export interface ICellCache {
  /**
   * 最后选择的   如果只剩一个 不允许再取消选中
   */
  lastSelected: ICellPosition;
  readonly multi: ICellPosition[];
  readonly ranges: ICellRange[];
  readonly isSelectedSingle: boolean;
  // readonly isSelected: boolean;
  isSelected(cell: ICellPosition): boolean;
  isExistSelectedCellOnRow(index: number): boolean;
  isExistSelectedCellOnColumn(index: number): boolean;
  findRange(cell: ICellPosition): ICellRange | undefined;
  /**
   * 无论如何会改变 lastSelected
   * @param cell
   */
  selectSingle(cell: ICellPosition): void;

  /**
   * 只有取消最后一个选择时 或者 取消一个 range 选中的单元格时  才不会改变 lastSelected
   * 其他任何时候都会改变
   * @param cell
   */
  selectMulti(cell: ICellPosition): void;

  /**
   * 无论如何都不会改变 lastSelected
   * @param range
   */
  selectRange(range: ICellRange): void;
  selectMultiRange(range: ICellRange): void;
  select(option: ISelectCellOption): void;
}
export class CellCache implements ICellCache {
  lastSelected: ICellPosition;
  private multiMap = new Map<string, ICellPosition>();
  private rangeArray: ICellRange[] = [];
  constructor(lastSelected: ICellPosition) {
    this.lastSelected = lastSelected;
    const { rowIndex, columnIndex } = lastSelected;
    const key = `${rowIndex}-${columnIndex}`;
    this.multiMap.set(key, lastSelected);
  }

  get multi(): ICellPosition[] {
    return Array.from(this.multiMap.values());
  }
  get ranges(): ICellRange[] {
    return this.rangeArray;
  }
  get isSelectedSingle(): boolean {
    if (this.rangeArray.length) {
      return false;
    }
    return this.multiMap.size === 1;
  }
  isSelected(cell: ICellPosition): boolean {
    if (this.multiMap.size) {
      const key = CellCache.toKey(cell);
      if (this.multiMap.has(key)) {
        return true;
      }
    }
    if (this.rangeArray.length) {
      return this.rangeArray.some((it) =>
        it.containCell(cell, { allowSameStart: true, allowSameEnd: true })
      );
    }
    return false;
  }
  isExistSelectedCellOnColumn(index: number): boolean {
    if (
      this.multiMap.size &&
      this.multi.some((it) => it.columnIndex === index)
    ) {
      return true;
    }
    if (this.rangeArray.length) {
      return this.rangeArray.some(
        (it) => it.start.columnIndex <= index && it.end.columnIndex >= index
      );
    }
    return false;
  }
  isExistSelectedCellOnRow(index: number): boolean {
    if (this.multiMap.size && this.multi.some((it) => it.rowIndex === index)) {
      return true;
    }
    if (this.rangeArray.length) {
      return this.rangeArray.some(
        (it) => it.start.rowIndex <= index && it.end.rowIndex >= index
      );
    }
    return false;
  }
  findRange(cell: ICellPosition): ICellRange | undefined {
    if (this.rangeArray.length) {
      return this.rangeArray.find((it) =>
        it.containCell(cell, { allowSameStart: true, allowSameEnd: true })
      );
    }
  }

  selectSingle(cell: ICellPosition): void {
    console.log("selectSingle", cell);
    this.multiMap.clear();
    this.rangeArray = [];
    const key = CellCache.toKey(cell);
    this.multiMap.set(key, cell);
    this.lastSelected = cell;
  }
  selectMulti(cell: ICellPosition): void {
    console.log("selectMulti");
    if (this.rangeArray.length) {
      const rangeIndex = this.rangeArray.findIndex((it) =>
        it.containCell(cell, { allowSameStart: true, allowSameEnd: true })
      );
      if (rangeIndex > -1) {
        const range = this.rangeArray[rangeIndex];
        const keep: ICellRange[] = [];
        const singleCell: ICellRange[] = [];
        CellCache.splitRangeByCell(range, cell).forEach((it) => {
          if (it.start.isSameCell(it.end)) {
            singleCell.push(it);
          } else {
            keep.push(it);
          }
        });
        this.rangeArray.replace(rangeIndex, 1, keep);
        if (singleCell.length) {
          singleCell.forEach((it) => {
            const key = CellCache.toKey(it.start);
            this.multiMap.set(key, it.start);
          });
        }
        this.rangeArray = keep;
        return;
      }
    }
    const key = CellCache.toKey(cell);
    if (this.multiMap.has(key)) {
      this.multiMap.delete(key);
      const multiArray = this.multi;
      if (multiArray.length) {
        this.lastSelected = multiArray[multiArray.length - 1];
      }
      return;
    }
    this.multiMap.set(key, cell);
    this.lastSelected = cell;
  }

  selectRange(range: ICellRange): void {
    console.log("selectRange");
    if (range.start.isSameCell(range.end)) {
      this.selectSingle(range.start);
      return;
    }
    const accurateRange = CellCache.adjustRange(range);
    if (this.multiMap.size) {
      this.multiMap.clear();
    }
    if (!this.lastSelected.isSameCell(accurateRange.start)) {
      this.lastSelected = accurateRange.start;
    }
    this.rangeArray = [accurateRange];
  }
  selectMultiRange(range: ICellRange): void {
    console.log("selectMultiRange");
    const accurateRange = CellCache.adjustRange(range);
    if (this.multiMap.size) {
      // 如果 range 包含多选选中的单元格  需要在多选中去掉这些交集单元格
      const keys = Array.from(this.multiMap.entries())
        .filter(([key, value]) =>
          accurateRange.containCell(value, {
            allowSameStart: true,
            allowSameEnd: true,
          })
        )
        .map(([key]) => key);
      keys.forEach((it) => this.multiMap.delete(it));
    }
    if (!this.lastSelected.isSameCell(accurateRange.start)) {
      this.lastSelected = accurateRange.start;
    }
    if (!this.rangeArray.length) {
      this.rangeArray.push(accurateRange);
      return;
    }
    const keep: ICellRange[] = [];
    const singleCell: ICellRange[] = [];
    this.rangeArray.forEach((it) => {
      if (CellCache.rangeHasMixed(it, accurateRange)) {
        keep.push(it);
        return;
      }
      CellCache.splitRange(it, accurateRange).forEach((split) => {
        if (split.start.isSameCell(split.end)) {
          singleCell.push(split);
        } else {
          keep.push(split);
        }
      });
    });
    if (singleCell.length) {
      singleCell.forEach((it) => {
        const key = CellCache.toKey(it.start);
        this.multiMap.set(key, it.start);
      });
    }
    this.rangeArray = keep;
  }

  select(option: ISelectCellOption): void {
    console.log(option);
    const { cell, isMulti, isRange } = option;
    if (isRange) {
      return this.selectRange(new CellRange(this.lastSelected, cell));
    }
    if (isMulti) {
      if (isRange) {
        return this.selectMultiRange(new CellRange(this.lastSelected, cell));
      }
      return this.selectMulti(cell);
    }
    return this.selectSingle(cell);
  }
  private static rangeHasMixed(range: ICellRange, other: ICellRange): boolean {
    const containLeftTop = range.containCell(other.start, {
      allowSameStart: true,
      allowSameEnd: true,
    });
    if (containLeftTop) {
      return true;
    }
    const containRightBottom = range.containCell(other.end, {
      allowSameStart: true,
      allowSameEnd: true,
    });
    if (containRightBottom) {
      return true;
    }
    const leftBottom = new CellPosition(
      other.end.rowIndex,
      other.start.columnIndex
    );
    const containLeftBottom = range.containCell(leftBottom, {
      allowSameStart: true,
      allowSameEnd: true,
    });
    if (containLeftBottom) {
      return true;
    }
    const topRight = new CellPosition(
      other.start.rowIndex,
      other.end.columnIndex
    );
    return range.containCell(topRight, {
      allowSameStart: true,
      allowSameEnd: true,
    });
  }
  private static splitRangeByCell(
    range: ICellRange,
    cell: ICellPosition
  ): ICellRange[] {
    const ruler = new CellRange(cell, cell);
    return this.splitRange(range, ruler);
  }
  private static splitRange(
    range: ICellRange,
    ruler: ICellRange
  ): ICellRange[] {
    //多向切割时  优先切割上下
    const result = [];
    const top = CellCache.splitTop(range, ruler);
    if (top) {
      result.push(top);
    }
    const bottom = CellCache.splitBottom(range, ruler);
    if (bottom) {
      result.push(bottom);
    }
    const left = CellCache.splitLeft(range, ruler);
    if (left) {
      result.push(left);
    }
    const right = CellCache.splitRight(range, ruler);
    if (right) {
      result.push(right);
    }
    return result;
  }
  private static splitTop(
    range: ICellRange,
    ruler: ICellRange
  ): ICellRange | undefined {
    if (range.start.rowIndex >= ruler.start.rowIndex) {
      return undefined;
    }
    const endRow = ruler.start.rowIndex - 1;
    const end = new CellPosition(endRow, range.end.columnIndex);
    return new CellRange(range.start, end);
  }
  private static splitBottom(
    range: ICellRange,
    ruler: ICellRange
  ): ICellRange | undefined {
    if (range.end.rowIndex <= ruler.end.rowIndex) {
      return undefined;
    }
    const startRow = ruler.end.rowIndex + 1;
    const start = new CellPosition(startRow, range.start.columnIndex);
    return new CellRange(start, range.end);
  }
  private static splitLeft(
    range: ICellRange,
    ruler: ICellRange
  ): ICellRange | undefined {
    if (range.start.columnIndex >= ruler.start.columnIndex) {
      return undefined;
    }
    const endColumn = ruler.start.columnIndex - 1;
    const start = new CellPosition(
      ruler.start.rowIndex,
      range.start.columnIndex
    );
    const end = new CellPosition(ruler.end.rowIndex, endColumn);
    return new CellRange(start, end);
  }
  private static splitRight(
    range: ICellRange,
    ruler: ICellRange
  ): ICellRange | undefined {
    if (range.end.columnIndex <= ruler.end.columnIndex) {
      return undefined;
    }
    const startColumn = ruler.start.columnIndex + 1;
    const start = new CellPosition(ruler.start.rowIndex, startColumn);
    const end = new CellPosition(ruler.end.rowIndex, range.end.columnIndex);
    return new CellRange(start, end);
  }

  private static adjustRange(range: ICellRange) {
    const { start, end } = range;
    const minRow = Math.min(start.rowIndex, end.rowIndex);
    const maxRow = Math.max(start.rowIndex, end.rowIndex);
    const minColumn = Math.min(start.columnIndex, end.columnIndex);
    const maxColumn = Math.max(start.columnIndex, end.columnIndex);
    if (
      start.rowIndex === minRow &&
      start.columnIndex === minColumn &&
      end.rowIndex === maxRow &&
      end.columnIndex === maxColumn
    ) {
      return range;
    }
    return new CellRange(
      new CellPosition(minRow, minColumn),
      new CellPosition(maxRow, maxColumn)
    );
  }
  private static toKey(cell: ICellPosition) {
    const { rowIndex, columnIndex } = cell;
    return `${rowIndex}-${columnIndex}`;
  }
}
